import { render, staticRenderFns } from "./scb.vue?vue&type=template&id=8639cee8&scoped=true&"
import script from "./scb.vue?vue&type=script&lang=js&"
export * from "./scb.vue?vue&type=script&lang=js&"
import style0 from "./scb.vue?vue&type=style&index=0&id=8639cee8&prod&scoped=true&lang=css&"
import style1 from "./scb.vue?vue&type=style&index=1&id=8639cee8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8639cee8",
  null
  
)

export default component.exports